// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__qKvC2","paramInput":"JobSimulator_paramInput__3idqh","input":"JobSimulator_input__8kUuF"};